export default "__VITE_ASSET__7424ef8d__"